/**
 * API fetch with credentials (cookies) and 401 handling.
 * Use for all /api calls so session cookie is sent and 401 redirects to login.
 */
export async function apiFetch(url, options = {}, retryOn401 = true) {
  const res = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      ...options.headers,
    },
  });
  if (res.status === 429) {
    throw new Error('تعداد درخواست‌ها زیاد است. کمی صبر کنید و دوباره تلاش کنید.');
  }
  if (
    res.status === 401 &&
    retryOn401 &&
    !url.startsWith('/api/auth/refresh') &&
    !url.startsWith('/api/auth/send-code') &&
    !url.startsWith('/api/auth/verify-code')
  ) {
    try {
      const refreshRes = await fetch('/api/auth/refresh', {
        method: 'POST',
        credentials: 'include',
      });
      if (refreshRes.ok) {
        return apiFetch(url, options, false);
      }
    } catch (e) {
      // ignore
    }
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new Error('نشست شما منقضی شده است.');
  }
  if (res.status === 401) {
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new Error('نشست شما منقضی شده است.');
  }
  return res;
}
